import { Mcap0RecordBuilder } from "./Mcap0RecordBuilder";
class ChunkBuilder {
    constructor({ useMessageIndex = true }) {
        this.recordWriter = new Mcap0RecordBuilder();
        this.totalMessageCount = 0;
        this.messageStartTime = 0n;
        this.messageEndTime = 0n;
        if (useMessageIndex) {
            this.messageIndices = new Map();
        }
    }
    get numMessages() {
        return this.totalMessageCount;
    }
    get buffer() {
        return this.recordWriter.buffer;
    }
    get byteLength() {
        return this.recordWriter.length;
    }
    get indices() {
        if (this.messageIndices) {
            return this.messageIndices.values();
        }
        return [];
    }
    addSchema(schema) {
        this.recordWriter.writeSchema(schema);
    }
    addChannel(info) {
        if (this.messageIndices && !this.messageIndices.has(info.id)) {
            this.messageIndices.set(info.id, {
                channelId: info.id,
                records: [],
            });
        }
        this.recordWriter.writeChannel(info);
    }
    addMessage(message) {
        if (this.totalMessageCount === 0 || message.logTime < this.messageStartTime) {
            this.messageStartTime = message.logTime;
        }
        if (this.totalMessageCount === 0 || message.logTime > this.messageEndTime) {
            this.messageEndTime = message.logTime;
        }
        if (this.messageIndices) {
            let messageIndex = this.messageIndices.get(message.channelId);
            if (!messageIndex) {
                messageIndex = {
                    channelId: message.channelId,
                    records: [],
                };
                this.messageIndices.set(message.channelId, messageIndex);
            }
            messageIndex.records.push([message.logTime, BigInt(this.recordWriter.length)]);
        }
        this.totalMessageCount += 1;
        this.recordWriter.writeMessage(message);
    }
    reset() {
        this.messageStartTime = 0n;
        this.messageEndTime = 0n;
        this.totalMessageCount = 0;
        this.messageIndices?.clear();
        this.recordWriter.reset();
    }
}
export { ChunkBuilder };
//# sourceMappingURL=ChunkBuilder.js.map